import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'x', 'X', [["path",{"d":"M18 6l-12 12"}],["path",{"d":"M6 6l12 12"}]]);